/* HWD Flaechen-Konfigurator

   Fuer alle Produkte mit FESTER Gravurflaeche: Zippo, Grillzange,
   Bieroeffner, Reserviert-Schild, Flachmann, Anhaenger. Was sich je Produkt
   unterscheidet, steht im Theme-Editor - Masse, Raender, Form, Material, ob
   es eine Rueckseite gibt. Der Code ist fuer alle derselbe.

   Abgrenzung zur Fotogravur (hwd-foto.js): Dort waehlt der Kunde das Format
   und laedt ein Foto mit echten Grautoenen. Hier steht das Format fest, und
   graviert werden Motive, Logos, Silhouetten und Text - deshalb laeuft jede
   Datei durch eine Maske statt durch die Tonwertkorrektur.

   Preis folgt der Gestaltung (optional): Manche Produkte verkaufen den
   Inhalt ueber eine Variantenoption - "Text 1 + Logo + Text 2", "nur Motiv"
   und so weiter. Der Kunde soll das nicht doppelt angeben. Deshalb liest der
   Konfigurator aus den Variantentiteln heraus, wie viele Texte und Motive
   jede Stufe erlaubt, zaehlt die tatsaechliche Gestaltung und waehlt die
   guenstigste passende Stufe. Die zugehoerige Auswahl oben am Produkt wird
   ausgeblendet, damit es nur eine Wahrheit gibt.

   Groesse folgt der Gestaltung (optional): Beim Herz fuer Tischnummer und
   Namensschild entscheidet nicht der Inhalt ueber den Preis, sondern die
   Groesse - mehr Flaeche heisst mehr Material und mehr Brennzeit. Steht im
   Theme-Editor eine Groessenliste, dann waehlt der Kunde sie im Konfigurator,
   die ganze Gestaltung skaliert mit, und der Konfigurator sucht die Variante
   mit der passenden Zahl im Optionswert. Die Groessenauswahl oben am Produkt
   wird ausgeblendet - auch hier soll es nur eine Wahrheit geben.

   Der Entwurf wird beim Kauf gesichert (_hwd), damit der Knopf "Gestaltung
   bearbeiten" im Warenkorb auch hier funktioniert.
*/
(function () {
  'use strict';

  var Kern = window.HWDKern, Bild = window.HWDBild;
  if (!Kern || !Bild) return;
  var K = Kern.K;

  var RASTER = [
    ['↖', 'links', 'oben'], ['↑', 'mitte', 'oben'], ['↗', 'rechts', 'oben'],
    ['←', 'links', 'mitte'], ['●', 'mitte', 'mitte'], ['→', 'rechts', 'mitte'],
    ['↙', 'links', 'unten'], ['↓', 'mitte', 'unten'], ['↘', 'rechts', 'unten']
  ];
  var SEITEN = ['vorne', 'hinten'];
  var NAME = { vorne: 'Vorderseite', hinten: 'Rückseite' };

  function el(tag, klasse, text) {
    var n = document.createElement(tag);
    if (klasse) n.className = klasse;
    if (text != null) n.textContent = text;
    return n;
  }

  function ereignis(name, daten) {
    try {
      window.dataLayer = window.dataLayer || [];
      var p = { event: 'hwd_' + name };
      for (var s in daten) if (daten.hasOwnProperty(s)) p[s] = daten[s];
      window.dataLayer.push(p);
      document.dispatchEvent(new CustomEvent('hwd:' + name, { detail: daten || {} }));
    } catch (e) { /* Analytics darf nie den Konfigurator stoppen */ }
  }

  function rgb(hex) {
    var h = String(hex).replace('#', '');
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    return [parseInt(h.slice(0, 2), 16) || 0, parseInt(h.slice(2, 4), 16) || 0, parseInt(h.slice(4, 6), 16) || 0];
  }
  function helligkeit(hex) {
    var c = rgb(hex);
    return (0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2]) / 255;
  }
  function gravurfarbe(grund) {
    return helligkeit(grund) > 0.62 ? '#4A3A2C' : '#EAE7E1';
  }

  function init(root) {
    if (root.dataset.ready === '1') return;
    root.dataset.ready = '1';

    var B = parseFloat(root.dataset.b) || 50;
    var H = parseFloat(root.dataset.h) || 50;
    var RANDX = parseFloat(root.dataset.randx) || 0;
    var RANDY = parseFloat(root.dataset.randy) || 0;
    var LINIE = parseFloat(root.dataset.linie) || 0;
    var RADIUS = parseFloat(root.dataset.radius) || 0;
    var LOCH = parseFloat(root.dataset.loch) || 0;
    var LOCHY = parseFloat(root.dataset.lochy) || 0;
    /* Sperrzone: ein Streifen, auf dem nichts liegen darf. Beim Nussholz-
       Anhaenger sitzt dort die Lasche mit dem Lederband. Vorne links, hinten
       rechts - das Werkstueck wird zum Gravieren umgedreht. */
    var SPERRE = parseFloat(root.dataset.sperre) || 0;
    var SPERRETEXT = (root.dataset.sperretext || '').trim() || 'Befestigung';
    /* Breite der geraden Schnittkante unten - nicht die Bogenhoehe.
       Die Tischnummer sitzt dort auf ihrer Unterkonstruktion. */
    var FLACH = parseFloat(root.dataset.flach) || 0;
    var GRUNDFARBE = root.dataset.grund || '#E8D9C0';
    var SEITENQUELLE = root.dataset.seiten || 'variante';
    var PREISFOLGT = root.dataset.preisfolgt === 'true';
    var STARTVARIANTE = root.dataset.startvariante || '';
    var FORMEN = String(root.dataset.formen || '').split(',')
      .map(function (s) { return s.trim(); }).filter(Boolean);
    var FORM = FORMEN.length ? FORMEN[0] : (root.dataset.form || 'rechteck');
    var GROESSEN = String(root.dataset.groessen || '').split(',')
      .map(function (s) { return parseFloat(String(s).replace(',', '.')); })
      .filter(function (n) { return n > 0; });
    /* Die Masse aus dem Theme-Editor sind der Bezug: bei dieser Groesse
       gelten Raender und Seitenverhaeltnis so, wie sie dort stehen. */
    var GRUNDB = B, GRUNDH = H, GRUNDRX = RANDX, GRUNDRY = RANDY;
    var MASSE = { b: B, h: H };

    if (B / H >= 4) root.classList.add('ist-breit');

    var VARIANTEN = [], FARBEN = {}, OPTIONEN = [];
    try { VARIANTEN = JSON.parse(root.querySelector('[data-hwd-varianten]').textContent); } catch (e) { /* leer */ }
    try { FARBEN = JSON.parse(root.querySelector('[data-hwd-farben]').textContent); } catch (e) { /* leer */ }
    try { OPTIONEN = JSON.parse(root.querySelector('[data-hwd-optionen]').textContent); } catch (e) { /* leer */ }

    var speicherSchluessel = 'hwd-flaeche-' + root.getAttribute('data-produkt');

    var bearbeitung = { id: null, key: null };
    try {
      var such = new URLSearchParams(window.location.search);
      bearbeitung.id = such.get('hwd');
      bearbeitung.key = such.get('hwd_key');
    } catch (e) { /* alter Browser */ }

    function neueSeite() {
      return { elemente: [], aktivId: null, naechsteId: 1, randX: RANDX, randY: RANDY,
        sperreLinks: 0, sperreRechts: 0 };
    }
    var z = {
      seite: 'vorne', schritt: 1, form: FORM, groesse: GRUNDB,
      seiten: { vorne: neueSeite(), hinten: neueSeite() }
    };

    var bilder = {}, cache = {};
    var naechsteBildId = Date.now() % 1000000;
    var variante = null;
    var beidseitig = SEITENQUELLE === 'immer';
    var grundfarbe = GRUNDFARBE, gravfarbe = gravurfarbe(GRUNDFARBE), farbname = '';
    var undoStapel = [], redoStapel = [], letzterStand = null;
    var belegTimer = null, zeichenTimer = null, bildTimer = null;
    var vorschauFeld = { vorne: null, hinten: null };

    var d = {
      canvas: root.querySelector('[data-hwd-canvas]'),
      leer: root.querySelector('[data-hwd-leer]'),
      wrap: root.querySelector('[data-hwd-wrap]'),
      status: root.querySelector('[data-hwd-status]'),
      seitenleiste: root.querySelector('[data-hwd-seiten]'),
      formenleiste: root.querySelector('[data-hwd-formen]'),
      groessenleiste: root.querySelector('[data-hwd-groessen]'),
      datei: root.querySelector('[data-hwd-datei]'),
      motivadd: root.querySelector('[data-hwd-motivadd]'),
      textadd: root.querySelector('[data-hwd-textadd]'),
      ebenenBild: root.querySelector('[data-hwd-ebenen-bild]'),
      ebenenText: root.querySelector('[data-hwd-ebenen-text]'),
      bildeditor: root.querySelector('[data-hwd-bildeditor]'),
      texteditor: root.querySelector('[data-hwd-texteditor]'),
      zusammen: root.querySelector('[data-hwd-zusammenfassung]'),
      ampeln: root.querySelector('[data-hwd-ampeln]'),
      dateien: root.querySelector('[data-hwd-dateien]'),
      undo: root.querySelector('[data-hwd-undo]'),
      redo: root.querySelector('[data-hwd-redo]'),
      reset: root.querySelector('[data-hwd-reset]'),
      korbhinweis: root.querySelector('[data-hwd-korbhinweis]'),
      legende: root.querySelector('[data-hwd-legende]'),
      skala: root.querySelector('[data-hwd-skala]'),
      preis: root.querySelector('[data-hwd-preis]'),
      preislabel: root.querySelector('[data-hwd-preislabel]')
    };
    var g = d.canvas.getContext('2d');

    function szene() { return z.seiten[z.seite]; }
    function aktiv() {
      var s = szene();
      for (var i = 0; i < s.elemente.length; i++) if (s.elemente[i].id === s.aktivId) return s.elemente[i];
      return null;
    }
    function nutz() { return { b: B - 2 * RANDX - SPERRE, h: H - 2 * RANDY }; }

    /* Vorne links, hinten rechts. Steht an einer Stelle, damit die beiden
       Seiten nicht auseinanderlaufen koennen. */
    function sperreSetzen() {
      z.seiten.vorne.sperreLinks = SPERRE;
      z.seiten.vorne.sperreRechts = 0;
      z.seiten.hinten.sperreLinks = 0;
      z.seiten.hinten.sperreRechts = SPERRE;
    }
    sperreSetzen();

    /* ---------- Formular ---------- */
    function form() {
      var fs = [].slice.call(document.querySelectorAll('form[action*="/cart/add"]'));
      for (var i = 0; i < fs.length; i++) if (fs[i].querySelector('[name="add"]')) return fs[i];
      return null;
    }
    function formId() { var f = form(); return f ? f.getAttribute('id') : null; }
    function kaufKnopf() { var f = form(); return f ? f.querySelector('[name="add"]') : null; }

    function setProp(name, wert) {
      var f = form(); if (!f) return;
      var i = f.querySelector('input[data-hwd-prop="' + name + '"]');
      if (!wert) { if (i) i.remove(); return; }
      if (!i) {
        i = document.createElement('input');
        i.type = 'hidden';
        i.setAttribute('data-hwd-prop', name);
        f.appendChild(i);
      }
      i.name = 'properties[' + name + ']';
      i.value = wert;
    }

    function alteFelderAusblenden() {
      [].slice.call(document.querySelectorAll('[name^="properties["]')).forEach(function (i) {
        if (i.hasAttribute('data-hwd-prop')) return;
        if (d.dateien && d.dateien.contains(i)) return;
        try { if (i.value) i.value = ''; } catch (e) { /* manche Browser sperren das */ }
        var box = i.closest ? (i.closest('.product-form__input') || i.parentElement) : i.parentElement;
        if (box && !box.hidden) box.hidden = true;
      });
    }

    /* ---------- Variante mitlesen ---------- */
    function findeVariante(id) {
      if (!id) return null;
      for (var i = 0; i < VARIANTEN.length; i++) {
        if (String(VARIANTEN[i].id) === String(id)) return VARIANTEN[i];
      }
      return null;
    }
    function ausAdresse() {
      try { return new URLSearchParams(window.location.search).get('variant'); } catch (e) { return null; }
    }
    /* Die Werte der Auswahlknöpfe oben, in der Reihenfolge der Optionen */
    function knopfWerte() {
      var werte = [];
      [].slice.call(document.querySelectorAll('variant-selects fieldset')).forEach(function (fs) {
        var an = fs.querySelector('input[type="radio"]:checked');
        if (an) { werte.push(String(an.value).trim()); return; }
        var sel = fs.querySelector('select');
        werte.push(sel ? String(sel.value).trim() : null);
      });
      return werte;
    }
    function ausKnoepfen() {
      var werte = knopfWerte().filter(function (w) { return w != null; });
      if (!werte.length) return null;
      var schluessel = werte.join('\u0001');
      for (var i = 0; i < VARIANTEN.length; i++) {
        if ((VARIANTEN[i].optionen || []).join('\u0001') === schluessel) return VARIANTEN[i];
      }
      return null;
    }

    /* ---------- Preis folgt der Gestaltung ---------- */
    var inhaltIdx = -1;
    if (PREISFOLGT) {
      for (var oi = 0; oi < OPTIONEN.length && inhaltIdx < 0; oi++) {
        for (var vi = 0; vi < VARIANTEN.length; vi++) {
          var wert = (VARIANTEN[vi].optionen || [])[oi] || '';
          if (/text|logo|motiv/i.test(wert)) { inhaltIdx = oi; break; }
        }
      }
    }

    /* Aus "Text 1 + Logo + Text 2" wird { t: 2, m: 1 } */
    function stufeZaehlen(wert) {
      var s = String(wert || '');
      return {
        t: (s.match(/text/gi) || []).length,
        m: (s.match(/logo|motiv/gi) || []).length
      };
    }
    /* Die vollste Seite bestimmt die Stufe */
    function gestaltungZaehlen() {
      var m = 0, t = 0;
      SEITEN.forEach(function (sn) {
        if (sn === 'hinten' && !beidseitig) return;
        var mm = 0, tt = 0;
        z.seiten[sn].elemente.forEach(function (e) {
          if (e.typ === 'bild') mm++; else tt++;
        });
        if (mm > m) m = mm;
        if (tt > t) t = tt;
      });
      return { m: m, t: t };
    }
    /* Aus einer Liste die guenstigste Stufe waehlen, die die Gestaltung
       traegt. Reicht keine, gewinnt die groesste - lieber zu viel Platz
       anbieten als den Kunden in eine zu kleine Stufe zwingen. */
    function stufeWaehlen(liste) {
      if (!liste.length) return null;
      if (!PREISFOLGT || inhaltIdx < 0) return liste[0];
      var gz = gestaltungZaehlen();
      var genug = liste.filter(function (v) {
        var c = stufeZaehlen((v.optionen || [])[inhaltIdx]);
        return c.m >= gz.m && c.t >= gz.t;
      });
      var l = (genug.length ? genug : liste).slice().sort(function (a, b) {
        return genug.length ? (a.cent - b.cent) : (b.cent - a.cent);
      });
      return l[0] || null;
    }

    function varianteNachGestaltung() {
      if (inhaltIdx < 0) return null;
      var werte = knopfWerte();
      var passend = VARIANTEN.filter(function (v) {
        var o = v.optionen || [];
        for (var i = 0; i < o.length; i++) {
          if (i === inhaltIdx) continue;
          if (werte[i] != null && werte[i] !== o[i]) return false;
        }
        return true;
      });
      return stufeWaehlen(passend.length ? passend : VARIANTEN.slice());
    }

    /* ---------- Preis folgt der Groesse ---------- */
    /* Welche Option traegt die Groesse? Die, deren Werte mit einer Zahl und
       "mm" anfangen - "60 mm", "100 mm". So bleibt die Schreibweise im Admin
       frei, solange die Zahl stimmt. */
    var groesseIdx = -1;
    if (GROESSEN.length) {
      for (var gi = 0; gi < 8 && groesseIdx < 0; gi++) {
        for (var gv = 0; gv < VARIANTEN.length; gv++) {
          var gw = (VARIANTEN[gv].optionen || [])[gi];
          if (gw != null && /\d\s*mm/i.test(String(gw))) { groesseIdx = gi; break; }
        }
      }
    }
    function groesseAusWert(wert) {
      var m = String(wert == null ? '' : wert).match(/\d+(?:[.,]\d+)?/);
      return m ? parseFloat(m[0].replace(',', '.')) : 0;
    }
    function varianteNachGroesse() {
      if (groesseIdx < 0) return null;
      var werte = knopfWerte();
      var treffer = VARIANTEN.filter(function (v) {
        var o = v.optionen || [];
        if (groesseAusWert(o[groesseIdx]) !== z.groesse) return false;
        for (var i = 0; i < o.length; i++) {
          if (i === groesseIdx || i === inhaltIdx) continue;
          if (werte[i] != null && werte[i] !== o[i]) return false;
        }
        return true;
      });
      return stufeWaehlen(treffer);
    }
    /* Die Groessenauswahl gehoert dorthin, wo der Kunde sie erwartet: oben
       beim Produkt, wo sonst die Variantenknoepfe stehen - nicht unten im
       Konfigurator. Shopifys eigenes Auswahlfeld wird ausgeblendet und die
       Leiste an seine Stelle gehaengt. Der Knoten wandert dabei aus dem
       Konfigurator heraus, deshalb haengt sein Klick-Lauscher an ihm selbst
       und nicht an der Wurzel.

       Wird jedes Mal geprueft: Sollte das Theme den Variantenblock einmal neu
       aufbauen, haengt sich die Leiste beim naechsten Zeichnen wieder ein. */
    function groessenauswahlAusblenden() {
      if (groesseIdx < 0 || !d.groessenleiste) return;
      var fs = document.querySelectorAll('variant-selects fieldset');
      var ziel = fs[groesseIdx];
      if (!ziel) return;
      if (!ziel.hidden) ziel.hidden = true;
      if (d.groessenleiste.nextElementSibling === ziel) return;
      ziel.parentElement.insertBefore(d.groessenleiste, ziel);
      /* hwd-fg traegt die Farbpalette des Konfigurators. Ausserhalb davon
         faende der aktive Knopf sein Orange nicht und stuende weiss auf
         weiss. Die Klasse mitzunehmen ist ehrlicher, als die Farben in der
         zweiten Datei noch einmal hinzuschreiben und sie dort veralten zu
         lassen; den Abstand, den hwd-fg mitbringt, nimmt das CSS zurueck. */
      d.groessenleiste.classList.add('hwd-fg', 'hwd-fl__formen--oben');
    }
    /* Groesse wechseln. Die Gestaltung skaliert mit, damit sie in der neuen
       Groesse genauso aussieht wie vorher - nur eben groesser. */
    function groesseSetzen(mm, skalieren) {
      if (!mm) return false;
      var alt = z.groesse || GRUNDB;
      if (mm === alt && MASSE.b === mm) return false;
      var f = mm / alt;
      z.groesse = mm;
      B = mm;
      H = mm * (GRUNDH / GRUNDB);
      MASSE.b = B; MASSE.h = H;
      RANDX = GRUNDRX * mm / GRUNDB;
      RANDY = GRUNDRY * mm / GRUNDB;
      SPERRE = SPERRE * mm / alt;
      FLACH = FLACH * mm / alt;
      sperreSetzen();
      SEITEN.forEach(function (sn) {
        var s = z.seiten[sn];
        s.randX = RANDX;
        s.randY = RANDY;
        if (!skalieren || f === 1) return;
        s.elemente.forEach(function (e) {
          e.x *= f; e.y *= f; e.breite *= f;
          if (e.typ === 'text') {
            e.mm *= f;
            if (e.laufweite) e.laufweite *= f;
          }
        });
      });
      cache = {};
      return true;
    }
    /* Die Inhalts-Auswahl oben waere doppelt - sie wird ausgeblendet.

       Muss wiederholbar sein: Waehlt der Kunde oben eine Variante, baut das
       Theme den Variantenblock neu auf. Dabei kommt das Auswahlfeld sichtbar
       zurueck - die alten Kombinationen standen ploetzlich wieder da. Die
       Funktion prueft deshalb jedes Mal nach und setzt den Hinweis nur,
       wenn er nicht schon davor steht. */
    function inhaltsauswahlAusblenden() {
      if (inhaltIdx < 0) return;
      var fs = document.querySelectorAll('variant-selects fieldset');
      var ziel = fs[inhaltIdx];
      if (!ziel) return;
      if (!ziel.hidden) ziel.hidden = true;
      var davor = ziel.previousElementSibling;
      if (davor && davor.classList && davor.classList.contains('hwd-fl__preisnote')) return;
      var hinweis = el('p', 'hwd-fl__preisnote',
        'Der Preis richtet sich nach deiner Gestaltung – du siehst ihn unten im Konfigurator.');
      ziel.parentElement.insertBefore(hinweis, ziel);
    }

    function gewaehlt() {
      if (groesseIdx >= 0) {
        var vg = varianteNachGroesse();
        if (vg) return vg;
      }
      if (PREISFOLGT) {
        var v = varianteNachGestaltung();
        if (v) return v;
      }
      return findeVariante(ausAdresse()) || ausKnoepfen()
        || findeVariante(STARTVARIANTE) || VARIANTEN[0] || null;
    }

    function setVariante(id) {
      var f = form(); if (!f) return;
      var i = f.querySelector('[name="id"]');
      if (!i) {
        i = document.createElement('input');
        i.type = 'hidden';
        i.name = 'id';
        f.appendChild(i);
      }
      if (i.value !== String(id)) i.value = String(id);
    }

    function preisAnzeigen() {
      if (!variante) return;
      var teile = [];
      if (SEITENQUELLE === 'variante') teile.push(beidseitig ? 'Beidseitig' : 'Einseitig');
      if (variante.farbe) teile.push(variante.farbe);
      if (groesseIdx >= 0) teile.push(Kern.kommazahl(z.groesse, 0) + ' mm');
      if (PREISFOLGT && inhaltIdx >= 0) teile.push((variante.optionen || [])[inhaltIdx]);
      if (!teile.length && variante.titel && variante.titel !== 'Default Title') teile.push(variante.titel);
      if (d.preislabel) d.preislabel.textContent = teile.join(' · ');
      if (d.preis) d.preis.textContent = variante.preis || '–';
    }

    function kaufbeschriftung() {
      var kb = kaufKnopf();
      if (!kb) return;
      var sp = kb.querySelector('span') || kb;
      var text = bearbeitung.key ? 'Änderung übernehmen'
        : (variante && variante.verfuegbar === false ? 'Zurzeit nicht verfügbar' : 'In den Warenkorb legen');
      if (sp.textContent.trim() !== text) sp.textContent = text;
    }

    var letzteVariante = null;
    function variantePruefen() {
      var v = gewaehlt();
      if (!v) return false;
      var kennung = v.id + '|' + v.farbe + '|' + v.beidseitig + '|' + v.verfuegbar;
      var neu = kennung !== letzteVariante;
      letzteVariante = kennung;
      variante = v;
      setVariante(v.id);
      if (neu) {
        if (SEITENQUELLE === 'variante') beidseitig = !!v.beidseitig;
        else beidseitig = SEITENQUELLE === 'immer';
        farbname = v.farbe || '';
        grundfarbe = FARBEN[v.farbe] || GRUNDFARBE;
        gravfarbe = gravurfarbe(grundfarbe);
        cache = {};
        if (!beidseitig && z.seite === 'hinten') z.seite = 'vorne';
        farbskala();
        seitenKnoepfe();
        vorschaufelder();
        dateienSyncen();
        alteFelderAusblenden();
        inhaltsauswahlAusblenden();
        groessenauswahlAusblenden();
      }
      preisAnzeigen();
      kaufbeschriftung();
      return neu;
    }

    function farbskala() {
      if (!d.skala) return;
      d.skala.style.background = 'linear-gradient(90deg,' + gravfarbe + ' 0%,' + grundfarbe + ' 100%)';
    }

    function seitenKnoepfe() {
      [].slice.call(root.querySelectorAll('[data-hwd-seite]')).forEach(function (b) {
        var s = b.getAttribute('data-hwd-seite');
        b.hidden = (s === 'hinten' && !beidseitig);
        var an = s === z.seite;
        b.classList.toggle('is-active', an);
        b.setAttribute('aria-pressed', an ? 'true' : 'false');
        var punkt = b.querySelector('.hwd-fl__punkt');
        if (punkt) punkt.hidden = !z.seiten[s].elemente.length;
      });
      if (d.seitenleiste) {
        d.seitenleiste.classList.toggle('ist-einseitig', !beidseitig);
        d.seitenleiste.hidden = (SEITENQUELLE === 'nie');
      }
    }

    /* ---------- Formwahl ---------- */
    function formKnoepfe() {
      if (!d.formenleiste || FORMEN.length < 2) {
        if (d.formenleiste) d.formenleiste.hidden = true;
        return;
      }
      if (d.formenleiste.dataset.ready === '1') {
        [].slice.call(d.formenleiste.querySelectorAll('[data-hwd-form]')).forEach(function (b) {
          var an = b.getAttribute('data-hwd-form') === z.form;
          b.classList.toggle('is-active', an);
          b.setAttribute('aria-pressed', an ? 'true' : 'false');
        });
        return;
      }
      d.formenleiste.dataset.ready = '1';
      d.formenleiste.hidden = false;
      d.formenleiste.appendChild(el('span', 'hwd-fg__label', 'Form'));
      FORMEN.forEach(function (f) {
        var b = el('button', 'hwd-fg__btn' + (f === z.form ? ' is-active' : ''), K.FORMNAMEN[f] || f);
        b.type = 'button';
        b.setAttribute('data-hwd-form', f);
        b.setAttribute('aria-pressed', f === z.form ? 'true' : 'false');
        d.formenleiste.appendChild(b);
      });
    }

    /* ---------- Groessenwahl ---------- */
    function groessenKnoepfe() {
      if (!d.groessenleiste || GROESSEN.length < 2) {
        if (d.groessenleiste) d.groessenleiste.hidden = true;
        return;
      }
      groessenauswahlAusblenden();
      if (d.groessenleiste.dataset.ready === '1') {
        [].slice.call(d.groessenleiste.querySelectorAll('[data-hwd-groesse]')).forEach(function (b) {
          var an = parseFloat(b.getAttribute('data-hwd-groesse')) === z.groesse;
          b.classList.toggle('is-active', an);
          b.setAttribute('aria-pressed', an ? 'true' : 'false');
        });
        return;
      }
      d.groessenleiste.dataset.ready = '1';
      d.groessenleiste.hidden = false;
      d.groessenleiste.appendChild(el('span', 'hwd-fg__label', 'Größe'));
      GROESSEN.forEach(function (mm) {
        var b = el('button', 'hwd-fg__btn' + (mm === z.groesse ? ' is-active' : ''),
          Kern.kommazahl(mm, 0) + ' mm');
        b.type = 'button';
        b.setAttribute('data-hwd-groesse', mm);
        b.setAttribute('aria-pressed', mm === z.groesse ? 'true' : 'false');
        d.groessenleiste.appendChild(b);
      });
    }

    /* ---------- Bildquelle ---------- */
    var nachrechnen = false;
    function bildQuelle(e, gr, pxProMm) {
      var reg = bilder[e.bildId];
      if (!reg) return null;
      var zielB = Math.max(40, Math.round(gr.b * pxProMm / 20) * 20);
      var zielH = Math.round(zielB * gr.h / gr.b);
      var key = [zielB, e.schwelle, e.umkehren ? 1 : 0, gravfarbe].join('|');
      var c = cache[e.id];
      if (c && c.key === key) return c.canvas;
      if (c && !nachrechnen) { bildSpaeter(); return c.canvas; }
      cache[e.id] = {
        key: key,
        canvas: Bild.silhouette(reg.arbeit, zielB, zielH, {
          farbe: rgb(gravfarbe), schwelle: e.schwelle, umkehren: e.umkehren
        })
      };
      return cache[e.id].canvas;
    }
    function bildSpaeter() {
      if (bildTimer) clearTimeout(bildTimer);
      bildTimer = setTimeout(function () { nachrechnen = true; zeichne(); nachrechnen = false; }, 140);
    }

    function zeichenOpt(beleg, saum) {
      var dunkel = helligkeit(grundfarbe) <= 0.62;
      return {
        grund: grundfarbe,
        brenn: gravfarbe,
        form: z.form,
        radius: RADIUS,
        flach: FLACH,
        loch: LOCH > 0 ? { d: LOCH, y: LOCHY || LOCH * 1.6 } : null,
        kontur: dunkel ? 'rgba(0,0,0,0.35)' : 'rgba(90,60,35,0.45)',
        massfarbe: 'rgba(90,90,95,0.75)',
        randfarbe: dunkel ? 'rgba(255,255,255,0.35)' : 'rgba(180,98,45,0.5)',
        linien: LINIE > 0 ? [{ y: LINIE }] : null,
        linienfarbe: dunkel ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.35)',
        bilder: bildQuelle,
        beleg: !!beleg,
        saum: saum || 0
      };
    }

    /* ---------- Zeichnen ---------- */
    function zeichne() {
      var s = szene();
      var saumPx = K.SAUM_PX;
      var platzB = d.wrap.clientWidth - 8;
      if (platzB < 160) platzB = 160;
      var eng = window.matchMedia('(max-width: 899px)').matches;
      var platzH = Math.max((eng ? 0.42 : 0.56) * window.innerHeight, 240);

      var pxProMm = Math.min((platzB - 2 * saumPx) / B, (platzH - 2 * saumPx) / H);
      if (pxProMm < 0.2) pxProMm = 0.2;
      var saum = saumPx / pxProMm;

      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var breitePx = Math.round(B * pxProMm) + 2 * saumPx;
      var hoehePx = Math.round(H * pxProMm) + 2 * saumPx;
      d.canvas.style.width = breitePx + 'px';
      d.canvas.style.height = hoehePx + 'px';
      d.canvas.width = Math.round(breitePx * dpr);
      d.canvas.height = Math.round(hoehePx * dpr);

      g.setTransform(dpr, 0, 0, dpr, 0, 0);
      g.clearRect(0, 0, breitePx, hoehePx);
      s.elemente.forEach(function (e) { if (e.typ === 'text') Kern.zeilenBerechnen(e); });

      var opt = zeichenOpt(false, saum);
      opt.auswahl = s.aktivId;
      Kern.zeichneSzene(g, s, MASSE, pxProMm, opt);

      d.leer.hidden = s.elemente.length > 0;
      d.canvas.classList.toggle('hat-elemente', s.elemente.length > 0);
      d.canvas.setAttribute('aria-label', beschreibung());
      legendeSchreiben();

      pruefung();
      propsSchreiben();
      belegSpaeter();
    }
    function zeichneBald() {
      if (zeichenTimer) return;
      zeichenTimer = requestAnimationFrame(function () { zeichenTimer = null; zeichne(); });
    }

    function legendeSchreiben() {
      if (!d.legende) return;
      var dunkel = helligkeit(grundfarbe) <= 0.62;
      var wer = farbname ? farbname + ': ' : '';
      d.legende.textContent = wer + (dunkel
        ? 'Helle Stellen werden graviert – dort trägt der Laser die Farbe ab. Der Rest bleibt stehen.'
        : 'Dunkle Stellen werden graviert – der helle Untergrund bleibt stehen.');
    }

    function namen(s) {
      var nb = 0, nt = 0, liste = [];
      s.elemente.forEach(function (e) {
        liste.push(e.typ === 'bild' ? 'Motiv ' + (++nb) : 'Text ' + (++nt));
      });
      return liste;
    }

    function beschreibung() {
      var s = szene(), nm = namen(s);
      var t = NAME[z.seite] + ', ' + Kern.kommazahl(B, 1) + ' mal ' + Kern.kommazahl(H, 1)
        + ' Millimeter, ' + s.elemente.length + ' Elemente.';
      s.elemente.forEach(function (e, i) {
        t += ' ' + nm[i] + ': ' + (e.typ === 'bild' ? (e.name || '') : e.text) + '.';
      });
      return t;
    }

    /* ---------- Pruefung ---------- */
    var probleme = [];
    function pruefung() {
      probleme = [];
      var n = nutz();

      if (variante && variante.verfuegbar === false) {
        probleme.push({ stufe: 'schlecht',
          text: 'Diese Ausführung ist zurzeit nicht verfügbar. Wähle oben eine andere.' });
      }

      SEITEN.forEach(function (sn) {
        if (sn === 'hinten' && !beidseitig) return;
        var s = z.seiten[sn];
        var nm = namen(s);
        var vorn = sn === 'vorne';
        if (!s.elemente.length) {
          probleme.push({ stufe: vorn ? 'schlecht' : 'mittel',
            text: NAME[sn] + ' ist noch leer.' });
          return;
        }
        s.elemente.forEach(function (e, i) {
          var name = (beidseitig ? NAME[sn] + ' · ' : '') + nm[i];
          var r = Kern.rahmen(e);
          var drin = Math.abs(e.x) < n.b / 2 + r.b / 2 - 2 && Math.abs(e.y) < n.h / 2 + r.h / 2 - 2;
          if (!drin) probleme.push({ stufe: 'schlecht', text: name + ' liegt fast vollständig neben der Fläche.' });
          if (SPERRE > 0) {
            var c = Kern.mitte(s, MASSE);
            var ragt = vorn ? (c.x + e.x - r.b / 2 < SPERRE - 0.5)
                            : (c.x + e.x + r.b / 2 > B - SPERRE + 0.5);
            /* Klammer statt Artikel: der Text kommt aus dem Theme-Editor,
               und „für die Lederband“ will niemand lesen. */
            if (ragt) probleme.push({ stufe: 'schlecht',
              text: name + ' ragt in den gesperrten Streifen (' + SPERRETEXT + ') – dort wird nichts graviert.' });
          }
          if (e.typ === 'bild') {
            if (!bilder[e.bildId]) {
              probleme.push({ stufe: 'schlecht', text: name + ': Datei fehlt, bitte erneut auswählen.' });
              return;
            }
            var q = Kern.qualitaet(e);
            if (bilder[e.bildId].vektor) {
              probleme.push({ stufe: 'gut', text: name + ': Vektordatei – beste Grundlage für eine saubere Kante.' });
            } else if (q.dpi < 90) {
              probleme.push({ stufe: 'mittel',
                text: name + ': nur rund ' + q.dpi + ' dpi. Als Silhouette geht das meist gut, feine Ecken können ausfransen.' });
            } else {
              probleme.push({ stufe: 'gut', text: name + ': rund ' + q.dpi + ' dpi – ausreichend für eine klare Kante.' });
            }
          } else {
            if (e.mm < K.SCHRIFT_MIN) probleme.push({ stufe: 'schlecht',
              text: name + ': Schrift unter ' + Kern.kommazahl(K.SCHRIFT_MIN, 1) + ' mm lässt sich nicht sauber gravieren.' });
            if (e.breite > n.b) probleme.push({ stufe: 'schlecht', text: name + ': Textblock ist breiter als die Fläche.' });
            if (Kern.textHoehe(e) > n.h) probleme.push({ stufe: 'schlecht', text: name + ': Textblock ist höher als die Fläche.' });
            if (/^\s*Dein Text\s*$/.test(e.text)) probleme.push({ stufe: 'mittel', text: name + ': Der Platzhalter „Dein Text“ wird so graviert.' });
          }
        });
      });

      if (!beidseitig && z.seiten.hinten.elemente.length) {
        probleme.push({ stufe: 'schlecht',
          text: 'Du hast die Rückseite gestaltet, aber „einseitig“ gewählt. '
            + 'Wähle oben „beidseitig“ oder leere die Rückseite – sonst geht die Gestaltung verloren.' });
      }

      var schlimm = probleme.filter(function (p) { return p.stufe === 'schlecht'; });
      var mittel = probleme.filter(function (p) { return p.stufe === 'mittel'; });
      if (schlimm.length) melde(schlimm[0].text, true);
      else if (mittel.length) melde(mittel[0].text, false);
      else melde('Fläche ' + Kern.kommazahl(n.b, 1) + ' × ' + Kern.kommazahl(n.h, 1) + ' mm nutzbar · '
        + (beidseitig ? 'beide Seiten' : 'eine Seite') + ' · alles im grünen Bereich.', false);

      var knopf = kaufKnopf();
      if (knopf) knopf.disabled = schlimm.length > 0;
      zusammenfassen();
    }

    function melde(text, warn) {
      d.status.textContent = text;
      d.status.classList.toggle('is-warn', !!warn);
    }

    function zusammenfassen() {
      var n = nutz();
      d.zusammen.innerHTML = '';
      var zeilen = [
        ['Werkstück', Kern.kommazahl(B, 1) + ' × ' + Kern.kommazahl(H, 1) + ' mm'
          + (FORMEN.length > 1 || z.form !== 'rechteck' ? ' · ' + (K.FORMNAMEN[z.form] || z.form) : '')],
        ['Gravurfläche', Kern.kommazahl(n.b, 1) + ' × ' + Kern.kommazahl(n.h, 1) + ' mm'
          + (RANDX || RANDY ? ' (Rand ' + Kern.kommazahl(RANDX, 1) + ' seitlich, '
            + Kern.kommazahl(RANDY, 1) + ' oben und unten)' : '')],
        ['Ausführung', (beidseitig ? 'beidseitig' : 'einseitig') + (farbname ? ' · ' + farbname : '')],
        ['Vorderseite', z.seiten.vorne.elemente.length + ' Element'
          + (z.seiten.vorne.elemente.length === 1 ? '' : 'e')]
      ];
      if (beidseitig) zeilen.push(['Rückseite', z.seiten.hinten.elemente.length + ' Element'
        + (z.seiten.hinten.elemente.length === 1 ? '' : 'e')]);
      zeilen.forEach(function (r) {
        d.zusammen.appendChild(el('dt', null, r[0]));
        d.zusammen.appendChild(el('dd', null, r[1]));
      });
      d.ampeln.innerHTML = '';
      probleme.forEach(function (p) {
        var zeile = el('div', 'hwd-fg__ampel ist-' + p.stufe);
        zeile.appendChild(el('span', 'hwd-fg__punkt hwd-fg__punkt--' + p.stufe));
        zeile.appendChild(el('span', null, p.text));
        d.ampeln.appendChild(zeile);
      });
    }

    /* ---------- Bestelldaten ---------- */
    function propsSchreiben() {
      var n = nutz();
      setProp('Gravurfläche', Kern.kommazahl(n.b, 1) + ' × ' + Kern.kommazahl(n.h, 1) + ' mm'
        + ' auf ' + Kern.kommazahl(B, 1) + ' × ' + Kern.kommazahl(H, 1) + ' mm'
        + (LINIE > 0 ? ' · Hilfslinie bei ' + Kern.kommazahl(LINIE, 1) + ' mm' : '')
        + (FLACH > 0 ? ' · unten ' + Kern.kommazahl(FLACH, 1) + ' mm gerade abgeschnitten' : ''));
      setProp('Form', FORMEN.length > 1 ? (K.FORMNAMEN[z.form] || z.form) : '');
      setProp('Größe', GROESSEN.length > 1 ? Kern.kommazahl(z.groesse, 0) + ' mm' : '');
      setProp('Sperrzone', SPERRE > 0
        ? Kern.kommazahl(SPERRE, 1) + ' mm (' + SPERRETEXT + ')'
          + ' · Vorderseite links, Rückseite rechts'
        : '');
      SEITEN.forEach(function (sn) {
        var s = z.seiten[sn];
        var nm = namen(s);
        var zeige = sn === 'vorne' || beidseitig;
        for (var i = 1; i <= K.MAX_ELEMENTE; i++) {
          var e = zeige ? s.elemente[i - 1] : null;
          var schluessel = NAME[sn] + ' Element ' + i;
          if (!e) { setProp(schluessel, ''); continue; }
          var pos = 'Position ' + Math.round(e.x) + '/' + Math.round(e.y) + ' mm ab Mitte';
          if (e.typ === 'bild') {
            var gr = Kern.bildMasse(e);
            setProp(schluessel, nm[i - 1] + ' ' + (e.name || '') + ' · ' + Math.round(gr.b) + ' × '
              + Math.round(gr.h) + ' mm · ' + pos
              + (e.drehung ? ' · ' + Math.round(e.drehung) + ' Grad' : '')
              + (e.umkehren ? ' · umgekehrt' : ''));
          } else {
            var stil = K.FONTNAMEN[e.font] + (e.fett ? ' fett' : '') + (e.kursiv ? ' kursiv' : '');
            setProp(schluessel, nm[i - 1] + ' „' + (e.zeilen || []).join(' / ') + '“ · '
              + Kern.kommazahl(e.mm, 1) + ' mm · ' + stil + ' · ' + K.AUSRICHTUNG[e.align]
              + ' · ' + pos + (e.drehung ? ' · ' + Math.round(e.drehung) + ' Grad' : ''));
          }
        }
      });
    }

    /* ---------- Dateifelder ---------- */
    function vorschaufelder() {
      var fid = formId();
      SEITEN.forEach(function (s) {
        if (vorschauFeld[s]) {
          if (fid) vorschauFeld[s].setAttribute('form', fid);
          return;
        }
        var i = document.createElement('input');
        i.type = 'file';
        i.name = 'properties[Gravurvorschau ' + NAME[s] + ']';
        i.tabIndex = -1;
        i.setAttribute('aria-hidden', 'true');
        if (fid) i.setAttribute('form', fid);
        d.dateien.appendChild(i);
        vorschauFeld[s] = i;
      });
    }

    function dateienSyncen() {
      [].slice.call(d.dateien.querySelectorAll('[data-hwd-slot]')).forEach(function (x) { x.remove(); });
      var n = 0, fid = formId();
      SEITEN.forEach(function (s) {
        if (s === 'hinten' && !beidseitig) return;
        z.seiten[s].elemente.forEach(function (e) {
          if (e.typ !== 'bild') return;
          var reg = bilder[e.bildId];
          if (!reg || !reg.datei) return;
          n++;
          var i = document.createElement('input');
          i.type = 'file';
          i.name = 'properties[Originalmotiv ' + n + ']';
          i.setAttribute('data-hwd-slot', '1');
          i.tabIndex = -1;
          i.setAttribute('aria-hidden', 'true');
          if (fid) i.setAttribute('form', fid);
          try { var dt = new DataTransfer(); dt.items.add(reg.datei); i.files = dt.files; } catch (err) { /* alt */ }
          d.dateien.insertBefore(i, vorschauFeld.vorne || null);
        });
      });
    }

    /* ---------- Beleg je Seite ---------- */
    function belegSpaeter() {
      if (belegTimer) clearTimeout(belegTimer);
      belegTimer = setTimeout(function () { belegeBauen(); }, 500);
    }

    function belegSeite(sn, fertig) {
      var feld = vorschauFeld[sn];
      if (!feld) { fertig(); return; }
      if (sn === 'hinten' && !beidseitig) {
        try { feld.files = new DataTransfer().files; } catch (e) { /* alt */ }
        fertig();
        return;
      }
      var ppm = Math.min(K.BELEG_PX_PRO_MM * 2, 3000 / Math.max(B, H));
      var c = document.createElement('canvas');
      c.width = Math.round(B * ppm);
      c.height = Math.round(H * ppm);
      var bg = c.getContext('2d');
      nachrechnen = true;
      Kern.zeichneSzene(bg, z.seiten[sn], MASSE, ppm, zeichenOpt(true, 0));
      nachrechnen = false;
      if (!c.toBlob) { fertig(); return; }
      try {
        c.toBlob(function (blob) {
          if (blob) {
            try {
              var dt = new DataTransfer();
              dt.items.add(new File([blob], 'gravur-' + sn + '.png', { type: 'image/png' }));
              feld.files = dt.files;
            } catch (e) { /* alt */ }
          }
          fertig();
        }, 'image/png');
      } catch (e) {
        fertig();
      }
    }

    function belegeBauen(fertig) {
      belegSeite('vorne', function () {
        belegSeite('hinten', function () { if (fertig) fertig(); });
      });
    }

    /* ---------- Entwurf sichern, Kauf ---------- */
    function entwuerfeAufraeumen() {
      var keys = [];
      for (var i = 0; i < localStorage.length; i++) {
        var k = localStorage.key(i);
        if (k && k.indexOf('hwd-entwurf-') === 0) keys.push(k);
      }
      keys.sort();
      while (keys.length > 12) { try { localStorage.removeItem(keys.shift()); } catch (e) { break; } }
    }

    function zustandJson() {
      var raus = { seite: z.seite, schritt: z.schritt, form: z.form, groesse: z.groesse, seiten: {} };
      SEITEN.forEach(function (sn) {
        var s = z.seiten[sn];
        raus.seiten[sn] = {
          aktivId: s.aktivId, naechsteId: s.naechsteId,
          elemente: s.elemente.map(Kern.ohneZeilen)
        };
      });
      return JSON.stringify(raus);
    }

    function zustandLesen(json) {
      var dd;
      try { dd = JSON.parse(json); } catch (e) { return false; }
      if (!dd || !dd.seiten) return false;
      /* Zuerst die Groesse: die gespeicherten Elemente sind in ihren
         Millimetern gemeint, sie duerfen nicht noch einmal skaliert werden. */
      if (GROESSEN.length && GROESSEN.indexOf(dd.groesse) >= 0) groesseSetzen(dd.groesse, false);
      sperreSetzen();
      SEITEN.forEach(function (sn) {
        var q = dd.seiten[sn] || {};
        var s = z.seiten[sn];
        s.elemente = q.elemente || [];
        s.aktivId = q.aktivId != null ? q.aktivId : null;
        s.naechsteId = q.naechsteId || 1;
        s.randX = RANDX;
        s.randY = RANDY;
        s.elemente.forEach(function (e) { if (e.typ === 'text') Kern.zeilenBerechnen(e); });
      });
      z.seite = dd.seite === 'hinten' ? 'hinten' : 'vorne';
      z.schritt = dd.schritt || 1;
      if (dd.form && FORMEN.indexOf(dd.form) >= 0) z.form = dd.form;
      return true;
    }

    function entwurfSichern() {
      var id = 'e' + Date.now().toString(36);
      try {
        localStorage.setItem('hwd-entwurf-' + id, zustandJson());
        entwuerfeAufraeumen();
      } catch (e) { /* Speicher voll: der Kauf darf trotzdem laufen */ }
      setProp('_hwd', id);
      return id;
    }

    function ersetzen(btn) {
      var f = form();
      if (!f) { baut = false; return; }
      var addUrl = (window.routes && routes.cart_add_url) || '/cart/add';
      var changeUrl = (window.routes && routes.cart_change_url) || '/cart/change';
      var cartUrl = (window.routes && routes.cart_url) || '/cart';
      btn.disabled = true;
      melde('Änderung wird übernommen …', false);
      fetch(addUrl, { method: 'POST', body: new FormData(f), headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () {
          return fetch(changeUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: bearbeitung.key, quantity: 0 })
          });
        })
        .then(function () { window.location.href = cartUrl; })
        .catch(function (err) {
          baut = false;
          btn.disabled = false;
          melde((err && err.description) || 'Die Änderung konnte nicht übernommen werden. Bitte versuche es noch einmal.', true);
        });
    }

    var baut = false, durchlassen = false;
    document.addEventListener('click', function (ev) {
      if (durchlassen || baut) return;
      var btn = ev.target && ev.target.closest ? ev.target.closest('[name="add"]') : null;
      if (!btn) return;
      var f = form();
      if (!f || !f.contains(btn)) return;
      ev.preventDefault();
      ev.stopImmediatePropagation();
      baut = true;
      belegeBauen(function () {
        entwurfSichern();
        ereignis('add_to_cart', { produkt: root.getAttribute('data-handle'), beidseitig: beidseitig });
        if (bearbeitung.key) { ersetzen(btn); return; }
        durchlassen = true;
        btn.click();
        durchlassen = false;
        baut = false;
      });
    }, true);

    /* ---------- Undo ---------- */
    function merken() {
      var jetzt = zustandJson();
      if (jetzt === letzterStand) return;
      if (letzterStand) { undoStapel.push(letzterStand); if (undoStapel.length > K.UNDO_TIEFE) undoStapel.shift(); }
      letzterStand = jetzt;
      redoStapel.length = 0;
      stapelKnoepfe();
      try { localStorage.setItem(speicherSchluessel, jetzt); } catch (e) { /* voll */ }
    }
    function stapelKnoepfe() {
      d.undo.disabled = !undoStapel.length;
      d.redo.disabled = !redoStapel.length;
    }
    function zurueck() {
      if (!undoStapel.length) return;
      redoStapel.push(letzterStand);
      letzterStand = undoStapel.pop();
      zustandLesen(letzterStand);
      cache = {};
      neuAufbauen();
      stapelKnoepfe();
    }
    function vor() {
      if (!redoStapel.length) return;
      undoStapel.push(letzterStand);
      letzterStand = redoStapel.pop();
      zustandLesen(letzterStand);
      cache = {};
      neuAufbauen();
      stapelKnoepfe();
    }

    /* ---------- Elemente ---------- */
    function fehler(text) {
      d.status.textContent = text;
      d.status.classList.add('is-warn');
    }

    function hatTransparenz(leinwand) {
      try {
        var g2 = leinwand.getContext('2d');
        var p = g2.getImageData(0, 0, leinwand.width, leinwand.height).data;
        for (var i = 3; i < p.length; i += 40) if (p[i] < 16) return true;
      } catch (e) { /* gesperrte Leinwand */ }
      return false;
    }

    function motivHinzu(datei) {
      var s = szene();
      if (s.elemente.length >= K.MAX_ELEMENTE) { fehler('Mehr Elemente passen auf diese Seite nicht.'); return; }
      if (datei.size > K.MAX_DATEI) {
        fehler('„' + datei.name + '“ ist zu groß. Höchstens 20 MB je Datei.');
        return;
      }
      var vektor = /svg/i.test(datei.type) || /\.svg$/i.test(datei.name);
      Bild.ladeDatei(datei).then(function (res) {
        var arbeit = Bild.arbeitskopie(res.img, vektor);
        var id = naechsteBildId++;
        bilder[id] = {
          img: res.img, url: res.url, datei: datei, name: datei.name, vektor: vektor,
          b: arbeit.width, h: arbeit.height, arbeit: arbeit,
          durchsichtig: hatTransparenz(arbeit)
        };
        var n = nutz();
        var ai = arbeit.width / arbeit.height;
        var passend = Math.min(n.b * 0.8, n.h * 0.8 * ai);
        s.elemente.push({
          id: s.naechsteId++, typ: 'bild', bildId: id, name: datei.name,
          x: 0, y: 0, breite: passend, drehung: 0,
          bildB: arbeit.width, bildH: arbeit.height,
          schwelle: 128, umkehren: false
        });
        s.aktivId = s.elemente[s.elemente.length - 1].id;
        ereignis('motiv_hinzu', { vektor: vektor });
        dateienSyncen();
        neuAufbauen();
        merken();
      }).catch(function () {
        fehler('„' + datei.name + '“ konnte nicht gelesen werden. PNG, JPG, WEBP oder SVG funktionieren.');
      });
    }

    function textHinzu() {
      var s = szene();
      if (s.elemente.length >= K.MAX_ELEMENTE) return;
      var n = nutz();
      var v = Kern.VORLAGEN[0];
      var anzahl = s.elemente.filter(function (e) { return e.typ === 'text'; }).length;
      var groesse = Math.max(K.SCHRIFT_MIN, Math.min(8, n.h * 0.45));
      s.elemente.push({
        id: s.naechsteId++, typ: 'text', text: 'Dein Text',
        x: 0, y: Math.min(anzahl * groesse * 1.4, Math.max(0, n.h / 2 - groesse)),
        breite: Math.round(n.b * 0.85), laufweite: 0, drehung: 0,
        vorlage: v.id, mm: Math.round(groesse * 2) / 2, font: v.font,
        fett: v.fett, kursiv: v.kursiv, align: v.align, za: v.za
      });
      s.aktivId = s.elemente[s.elemente.length - 1].id;
      ereignis('text_hinzu', {});
      neuAufbauen();
      merken();
    }

    function entferne(e) {
      var s = szene();
      var i = s.elemente.indexOf(e);
      if (i < 0) return;
      s.elemente.splice(i, 1);
      delete cache[e.id];
      s.aktivId = s.elemente.length ? s.elemente[s.elemente.length - 1].id : null;
      dateienSyncen();
      neuAufbauen();
      merken();
    }

    /* ---------- Ebenen ---------- */
    function ebenenBauen() {
      d.ebenenBild.innerHTML = '';
      d.ebenenText.innerHTML = '';
      var s = szene(), nb = 0, nt = 0;
      s.elemente.forEach(function (e) {
        var li = el('li');
        var b = el('button', 'hwd-fg__ebene');
        b.type = 'button';
        b.setAttribute('data-hwd-ebene', String(e.id));
        if (e.typ === 'bild') {
          nb++;
          var reg = bilder[e.bildId];
          if (reg) { var im = new Image(); im.src = reg.url; im.alt = ''; b.appendChild(im); }
          b.appendChild(el('b', null, 'Motiv ' + nb));
          b.appendChild(el('em', null, reg ? (reg.vektor ? 'Vektor' : Kern.qualitaet(e).dpi + ' dpi') : 'fehlt'));
          li.appendChild(b);
          li.appendChild(wegKnopf(e, 'Motiv ' + nb + ' entfernen'));
          d.ebenenBild.appendChild(li);
        } else {
          nt++;
          var t = String(e.text).replace(/\n/g, ' ');
          if (t.length > 22) t = t.slice(0, 21) + '…';
          b.appendChild(el('b', null, '„' + t + '“'));
          b.appendChild(el('em', null, Kern.kommazahl(e.mm, 1) + ' mm'));
          li.appendChild(b);
          li.appendChild(wegKnopf(e, 'Text ' + nt + ' entfernen'));
          d.ebenenText.appendChild(li);
        }
        li.style.display = 'flex';
        li.style.alignItems = 'center';
        li.style.gap = '.4rem';
      });
      ebenenMarkieren();
    }
    function wegKnopf(e, beschriftung) {
      var w = el('button', 'hwd-fg__ebeneweg', '×');
      w.type = 'button';
      w.setAttribute('aria-label', beschriftung);
      w.addEventListener('click', function (ev) { ev.stopPropagation(); entferne(e); });
      return w;
    }
    function ebenenMarkieren() {
      var s = szene();
      [].slice.call(root.querySelectorAll('[data-hwd-ebene]')).forEach(function (b) {
        b.classList.toggle('is-aktiv', b.getAttribute('data-hwd-ebene') === String(s.aktivId));
      });
    }

    /* ---------- Bausteine ---------- */
    function regler(beschriftung, min, max, schritt, wert, einheit, beiAenderung) {
      var feld = el('div', 'hwd-fg__field');
      var lab = el('label', 'hwd-fg__label');
      var out = el('output', null, String(wert).replace('.', ','));
      lab.appendChild(document.createTextNode(beschriftung + ' '));
      lab.appendChild(out);
      lab.appendChild(document.createTextNode(' ' + einheit));
      var r = el('input', 'hwd-fg__range');
      r.type = 'range'; r.min = min; r.max = max; r.step = schritt; r.value = wert;
      r.id = 'hwdFR' + (regler.zaehler = (regler.zaehler || 0) + 1);
      lab.setAttribute('for', r.id);
      r.addEventListener('input', function () {
        out.textContent = String(r.value).replace('.', ',');
        beiAenderung(parseFloat(r.value));
        zeichneBald();
      });
      r.addEventListener('change', merken);
      feld.appendChild(lab); feld.appendChild(r);
      return feld;
    }

    function zahl(beschriftung, min, max, schritt, wert, beiAenderung) {
      var lab = el('label', 'hwd-fg__zahl');
      lab.appendChild(el('span', null, beschriftung));
      var i = el('input');
      i.type = 'number'; i.min = min; i.max = max; i.step = schritt;
      i.value = wert; i.inputMode = 'decimal';
      i.addEventListener('input', function () {
        var v = parseFloat(i.value);
        if (isNaN(v)) return;
        beiAenderung(Math.max(min, Math.min(max, v)));
        ebenenBauen();
        zeichneBald();
      });
      i.addEventListener('change', merken);
      lab.appendChild(i);
      return lab;
    }

    function knopfReihe(beschriftung, eintraege, istAktiv, beiKlick) {
      var feld = el('div', 'hwd-fg__field');
      if (beschriftung) feld.appendChild(el('span', 'hwd-fg__label', beschriftung));
      var reihe = el('div', 'hwd-fg__schalter');
      eintraege.forEach(function (x) {
        if (x.trenner) { reihe.appendChild(el('span', 'hwd-fg__trenner')); return; }
        var b = el('button', (x.schrift ? 'hwd-fg__font' : 'hwd-fg__btn') + (x.klasse ? ' ' + x.klasse : ''), x.name);
        b.type = 'button';
        if (x.schrift) b.setAttribute('data-hwd-font', x.id);
        b.setAttribute('aria-pressed', istAktiv(x) ? 'true' : 'false');
        if (istAktiv(x)) b.classList.add('is-active');
        b.addEventListener('click', function () { beiKlick(x); merken(); editorBauen(); ebenenBauen(); zeichne(); });
        reihe.appendChild(b);
      });
      feld.appendChild(reihe);
      return feld;
    }

    function ausrichtraster(e) {
      var feld = el('div', 'hwd-fg__field');
      feld.appendChild(el('span', 'hwd-fg__label', 'Ausrichten'));
      var gitter = el('div', 'hwd-fg__raster');
      RASTER.forEach(function (p) {
        var b = el('button', null, p[0]);
        b.type = 'button';
        b.setAttribute('aria-label', 'Ausrichten ' + p[1] + ' ' + p[2]);
        b.addEventListener('click', function () {
          var n = nutz();
          var r = Kern.rahmen(e);
          e.x = p[1] === 'links' ? -(n.b - r.b) / 2 : (p[1] === 'rechts' ? (n.b - r.b) / 2 : 0);
          e.y = p[2] === 'oben' ? -(n.h - r.h) / 2 : (p[2] === 'unten' ? (n.h - r.h) / 2 : 0);
          zeichne(); merken();
        });
        gitter.appendChild(b);
      });
      feld.appendChild(gitter);
      return feld;
    }

    /* ---------- Editoren ---------- */
    function editorBauen() {
      var e = aktiv();
      d.bildeditor.hidden = !(e && e.typ === 'bild');
      d.texteditor.hidden = !(e && e.typ === 'text');
      if (!e) return;
      var ziel = e.typ === 'bild' ? d.bildeditor : d.texteditor;
      ziel.innerHTML = '';
      var n = nutz();

      if (e.typ === 'bild') {
        var reg = bilder[e.bildId];
        var ai = e.bildB / e.bildH;
        var deckend = Math.max(n.b, n.h * ai);
        var proz = Math.round(e.breite / deckend * 100);
        ziel.appendChild(regler('Skalieren', 2, 200, 1, Math.max(2, proz), '%', function (v) {
          e.breite = deckend * v / 100;
        }));
        ziel.appendChild(regler('Drehen', -180, 180, 1, Math.round(e.drehung || 0), '°', function (v) {
          e.drehung = v;
        }));
        if (reg && !reg.durchsichtig) {
          ziel.appendChild(regler('Schwelle hell/dunkel', 20, 235, 1, e.schwelle, '', function (v) {
            e.schwelle = v;
          }));
        }
        ziel.appendChild(knopfReihe('Motiv', [{ id: 'um', name: 'Umkehren' }],
          function () { return !!e.umkehren; },
          function () { e.umkehren = !e.umkehren; }));
        ziel.appendChild(ausrichtraster(e));
        ziel.appendChild(el('p', 'hwd-fg__mini', reg && reg.durchsichtig
          ? 'Freigestelltes Motiv erkannt – graviert wird genau das Sichtbare.'
          : 'Alles Dunkle wird graviert. Mit der Schwelle bestimmst du, wo die Grenze liegt.'));
        return;
      }

      var feld = el('div', 'hwd-fg__field');
      var lab = el('label', 'hwd-fg__label', 'Text');
      lab.setAttribute('for', 'hwdFText' + e.id);
      var ta = el('textarea', 'hwd-fg__input hwd-fg__textarea');
      ta.id = 'hwdFText' + e.id;
      ta.rows = 2; ta.maxLength = 300; ta.value = e.text;
      ta.addEventListener('input', function () {
        e.text = ta.value;
        Kern.zeilenBerechnen(e);
        ebenenBauen(); zeichneBald();
      });
      ta.addEventListener('change', merken);
      feld.appendChild(lab); feld.appendChild(ta);
      ziel.appendChild(feld);

      function loest() { e.vorlage = null; }

      ziel.appendChild(knopfReihe('Schriftart', [
        { id: 'serif', name: 'Klassisch', schrift: true },
        { id: 'sans', name: 'Schlicht', schrift: true },
        { id: 'script', name: 'Handschrift', schrift: true }
      ], function (x) { return e.font === x.id; }, function (x) { e.font = x.id; loest(); }));

      ziel.appendChild(knopfReihe('Stil und Ausrichtung', [
        { id: 'fett', name: 'F', klasse: 'hwd-fg__btn--icon ist-fett' },
        { id: 'kursiv', name: 'K', klasse: 'hwd-fg__btn--icon ist-kursiv' },
        { trenner: true },
        { id: 'links', name: 'links' }, { id: 'mitte', name: 'zentriert' }, { id: 'rechts', name: 'rechts' }
      ], function (x) {
        if (x.id === 'fett') return !!e.fett;
        if (x.id === 'kursiv') return !!e.kursiv;
        return e.align === x.id;
      }, function (x) {
        if (x.id === 'fett') e.fett = !e.fett;
        else if (x.id === 'kursiv') e.kursiv = !e.kursiv;
        else e.align = x.id;
        loest();
      }));

      var zFeld = el('div', 'hwd-fg__field');
      var gitter = el('div', 'hwd-fg__zahlen');
      gitter.appendChild(zahl('Schriftgröße in mm', K.SCHRIFT_MIN, Math.max(6, Math.round(n.h)), 0.5, e.mm, function (v) { e.mm = v; loest(); }));
      gitter.appendChild(zahl('Zeilenabstand', 1, 2.5, 0.05, e.za, function (v) { e.za = v; loest(); }));
      gitter.appendChild(zahl('Textbreite in mm', 8, Math.round(n.b), 1, Math.round(e.breite), function (v) { e.breite = v; }));
      gitter.appendChild(zahl('Buchstabenabstand', 0, 3, 0.1, e.laufweite || 0, function (v) { e.laufweite = v; }));
      zFeld.appendChild(gitter);
      ziel.appendChild(zFeld);

      ziel.appendChild(ausrichtraster(e));
    }

    /* ---------- Vorschau bedienen ---------- */
    function skala() {
      var breite = d.canvas.clientWidth || d.canvas.width;
      var ppm = (breite - 2 * K.SAUM_PX) / B;
      if (!(ppm > 0.05)) ppm = 1;
      return { ppm: ppm, saum: K.SAUM_PX / ppm };
    }
    function mmAusEreignis(ev) {
      var s = skala();
      var r = d.canvas.getBoundingClientRect();
      var f = r.width ? (d.canvas.clientWidth || r.width) / r.width : 1;
      var px = (ev.clientX - r.left) * f, py = (ev.clientY - r.top) * f;
      return { x: (px - K.SAUM_PX) / s.ppm, y: (py - K.SAUM_PX) / s.ppm, ppm: s.ppm, saum: s.saum };
    }

    var tun = null;
    d.canvas.addEventListener('pointerdown', function (ev) {
      var s = szene();
      var p = mmAusEreignis(ev);
      var tr = Kern.greifen(s, MASSE, p.x, p.y, p.ppm, s.aktivId, p.saum);
      if (!tr) { s.aktivId = null; editorBauen(); ebenenMarkieren(); zeichne(); return; }
      ev.preventDefault();
      if (tr.element.id !== s.aktivId) { s.aktivId = tr.element.id; editorBauen(); ebenenMarkieren(); }
      var c = Kern.mitte(s, MASSE);
      var e = tr.element;
      tun = {
        art: tr.art, e: e, sx: p.x, sy: p.y, ax: e.x, ay: e.y,
        breite: e.breite, mm: e.mm, dreh: e.drehung || 0,
        cx: c.x + e.x, cy: c.y + e.y
      };
      tun.dist = Math.max(0.5, Math.sqrt(Math.pow(p.x - tun.cx, 2) + Math.pow(p.y - tun.cy, 2)));
      tun.winkel = Math.atan2(p.y - tun.cy, p.x - tun.cx);
      d.canvas.classList.add(tr.art === 'drehen' ? 'dreht' : (tr.art === 'skalieren' ? 'skaliert' : 'zieht'));
      if (d.canvas.setPointerCapture) d.canvas.setPointerCapture(ev.pointerId);
      zeichne();
    });

    d.canvas.addEventListener('pointermove', function (ev) {
      var p = mmAusEreignis(ev);
      if (!tun) {
        var s = szene();
        if (!s.elemente.length) return;
        var tr = Kern.greifen(s, MASSE, p.x, p.y, p.ppm, s.aktivId, p.saum);
        d.canvas.classList.remove('dreht', 'skaliert');
        if (tr && tr.art === 'drehen') d.canvas.classList.add('dreht');
        else if (tr && tr.art === 'skalieren') d.canvas.classList.add('skaliert');
        return;
      }
      var e = tun.e;
      if (tun.art === 'bewegen') {
        var grenze = Math.max(B, H);
        e.x = Math.max(-grenze, Math.min(grenze, tun.ax + (p.x - tun.sx)));
        e.y = Math.max(-grenze, Math.min(grenze, tun.ay + (p.y - tun.sy)));
      } else if (tun.art === 'skalieren') {
        var jetzt = Math.sqrt(Math.pow(p.x - tun.cx, 2) + Math.pow(p.y - tun.cy, 2));
        var f = jetzt / tun.dist;
        e.breite = Math.max(3, Math.min(B * 3, tun.breite * f));
        if (e.typ === 'text') e.mm = Math.max(2, Math.min(80, tun.mm * f));
      } else {
        var w = Math.atan2(p.y - tun.cy, p.x - tun.cx) - tun.winkel;
        var grad = tun.dreh + w * 180 / Math.PI;
        grad = ((grad % 360) + 540) % 360 - 180;
        [-180, -90, 0, 90, 180].forEach(function (r) { if (Math.abs(grad - r) < 4) grad = r; });
        e.drehung = Math.round(grad);
      }
      zeichneBald();
    });

    function endeZiehen() {
      if (!tun) return;
      tun = null;
      d.canvas.classList.remove('zieht', 'dreht', 'skaliert');
      editorBauen();
      ebenenBauen();
      merken();
      zeichne();
    }
    d.canvas.addEventListener('pointerup', endeZiehen);
    d.canvas.addEventListener('pointercancel', endeZiehen);

    d.canvas.addEventListener('keydown', function (ev) {
      var e = aktiv();
      if (!e) return;
      var s = ev.shiftKey ? 5 : 1, bewegt = true;
      if (ev.key === 'ArrowLeft') e.x -= s;
      else if (ev.key === 'ArrowRight') e.x += s;
      else if (ev.key === 'ArrowUp') e.y -= s;
      else if (ev.key === 'ArrowDown') e.y += s;
      else if (ev.key === 'Delete' || ev.key === 'Backspace') { entferne(e); return; }
      else bewegt = false;
      if (bewegt) { ev.preventDefault(); zeichne(); merken(); }
    });

    /* ---------- Reiter und Klicks ---------- */
    function schritt(nr) {
      z.schritt = nr;
      [].slice.call(root.querySelectorAll('[data-hwd-schritt]')).forEach(function (b) {
        var an = b.getAttribute('data-hwd-schritt') === String(nr);
        b.classList.toggle('is-active', an);
        b.setAttribute('aria-selected', an ? 'true' : 'false');
      });
      [].slice.call(root.querySelectorAll('[data-hwd-panel]')).forEach(function (p) {
        p.hidden = p.getAttribute('data-hwd-panel') !== String(nr);
      });
      var s = szene();
      var s1 = root.querySelector('[data-hwd-schritt="1"]');
      var s2 = root.querySelector('[data-hwd-schritt="2"]');
      if (s1) s1.classList.toggle('hat-inhalt', s.elemente.some(function (e) { return e.typ === 'bild'; }));
      if (s2) s2.classList.toggle('hat-inhalt', s.elemente.some(function (e) { return e.typ === 'text'; }));
    }

    root.addEventListener('click', function (ev) {
      var t = ev.target.closest ? ev.target : null;
      if (!t) return;
      var sk = t.closest('[data-hwd-schritt]');
      if (sk) { schritt(parseInt(sk.getAttribute('data-hwd-schritt'), 10)); return; }
      var fo = t.closest('[data-hwd-form]');
      if (fo) {
        z.form = fo.getAttribute('data-hwd-form');
        cache = {};
        formKnoepfe();
        neuAufbauen();
        merken();
        return;
      }
      var se = t.closest('[data-hwd-seite]');
      if (se) {
        var wohin = se.getAttribute('data-hwd-seite');
        if (wohin === 'hinten' && !beidseitig) return;
        z.seite = wohin;
        seitenKnoepfe();
        neuAufbauen();
        return;
      }
      var eb = t.closest('[data-hwd-ebene]');
      if (eb) {
        var id = parseInt(eb.getAttribute('data-hwd-ebene'), 10);
        var s = szene();
        for (var i = 0; i < s.elemente.length; i++) {
          if (s.elemente[i].id === id) { s.aktivId = id; editorBauen(); ebenenMarkieren(); zeichne(); }
        }
      }
    });

    /* Eigener Lauscher: die Groessenleiste steht oben beim Produkt und
       damit ausserhalb des Konfigurators. */
    if (d.groessenleiste) {
      d.groessenleiste.addEventListener('click', function (ev) {
        var b = ev.target && ev.target.closest ? ev.target.closest('[data-hwd-groesse]') : null;
        if (!b) return;
        if (!groesseSetzen(parseFloat(b.getAttribute('data-hwd-groesse')), true)) return;
        groessenKnoepfe();
        variantePruefen();
        neuAufbauen();
        merken();
      });
    }

    /* Waehlt der Kunde oben eine Variante, baut das Theme den Variantenblock
       neu auf: die ausgeblendete Auswahl kommt sichtbar zurueck und die
       eingehaengte Groessenleiste fliegt heraus. Ein Beobachter haengt beides
       sofort wieder richtig - schneller und zuverlaessiger als ein Zeitgeber,
       weil er genau dann anspringt, wenn das Theme fertig ist.

       Beobachtet wird die Ebene ueber der Variantenwahl, damit es auch dann
       noch greift, wenn das Theme das Element selbst austauscht. Die beiden
       Funktionen aendern nichts, wenn schon alles stimmt - der Beobachter
       kann sich also nicht selbst im Kreis anstossen. */
    function auswahlNachziehen() {
      inhaltsauswahlAusblenden();
      groessenauswahlAusblenden();
    }
    if (inhaltIdx >= 0 || groesseIdx >= 0) {
      try {
        var vs = document.querySelector('variant-selects');
        if (vs && vs.parentElement && window.MutationObserver) {
          new MutationObserver(auswahlNachziehen)
            .observe(vs.parentElement, { childList: true, subtree: true });
        }
      } catch (e) { /* ohne Beobachter greift der Zeitgeber weiter unten */ }
      document.addEventListener('change', function (ev) {
        if (!ev.target || !ev.target.closest || !ev.target.closest('variant-selects')) return;
        setTimeout(auswahlNachziehen, 120);
        setTimeout(auswahlNachziehen, 450);
      });
    }

    d.motivadd.addEventListener('click', function () { d.datei.click(); });
    d.datei.addEventListener('change', function () {
      [].slice.call(d.datei.files || []).forEach(motivHinzu);
      d.datei.value = '';
    });
    d.textadd.addEventListener('click', textHinzu);
    d.undo.addEventListener('click', zurueck);
    d.redo.addEventListener('click', vor);
    d.reset.addEventListener('click', function () {
      if (!window.confirm('Gestaltung zurücksetzen?')) return;
      z.seiten.vorne = neueSeite();
      z.seiten.hinten = neueSeite();
      z.seite = 'vorne';
      cache = {};
      try { localStorage.removeItem(speicherSchluessel); } catch (e) { /* egal */ }
      dateienSyncen();
      neuAufbauen();
      merken();
    });

    function neuAufbauen() {
      seitenKnoepfe();
      formKnoepfe();
      groessenKnoepfe();
      inhaltsauswahlAusblenden();
      ebenenBauen();
      editorBauen();
      alteFelderAusblenden();
      d.motivadd.textContent = szene().elemente.some(function (e) { return e.typ === 'bild'; })
        ? 'Weiteres Motiv' : 'Motiv auswählen';
      schritt(z.schritt || 1);
      zeichne();
    }

    /* ---------- Motive einer Warenkorbposition nachholen ---------- */
    function dateiname(u) {
      var t = String(u).split('?')[0].split('/').pop() || 'motiv.png';
      try { t = decodeURIComponent(t); } catch (e) { /* roh */ }
      return t.length > 60 ? t.slice(t.length - 60) : t;
    }

    function motiveNachholen() {
      var offen = [];
      SEITEN.forEach(function (sn) {
        z.seiten[sn].elemente.forEach(function (e) {
          if (e.typ === 'bild') { e.bildId = naechsteBildId++; offen.push(e); }
        });
      });
      if (!offen.length) return;

      var quellen = [];
      try {
        var roh = sessionStorage.getItem('hwd-fotos-' + bearbeitung.id);
        if (roh) quellen = roh.split('\n').filter(function (s) { return s; });
      } catch (e) { /* ohne Adressen */ }
      if (!quellen.length) {
        fehler('Texte und Anordnung sind zurück. Die Motive musst du erneut auswählen.');
        return;
      }

      offen.forEach(function (e, i) {
        var u = quellen[i];
        if (!u) return;
        fetch(u)
          .then(function (r) { if (!r.ok) throw new Error('http'); return r.blob(); })
          .then(function (blob) {
            var name = dateiname(u);
            var vektor = /svg/i.test(blob.type) || /\.svg$/i.test(name);
            var datei = new File([blob], name, { type: blob.type || 'image/png' });
            return Bild.ladeDatei(datei).then(function (res) {
              var arbeit = Bild.arbeitskopie(res.img, vektor);
              bilder[e.bildId] = {
                img: res.img, url: res.url, datei: datei, name: name, vektor: vektor,
                b: arbeit.width, h: arbeit.height, arbeit: arbeit,
                durchsichtig: hatTransparenz(arbeit)
              };
              e.bildB = arbeit.width; e.bildH = arbeit.height; e.name = name;
              dateienSyncen();
              neuAufbauen();
            });
          })
          .catch(function () {
            fehler('Ein Motiv konnte nicht mitgenommen werden – bitte wähle es erneut aus.');
            neuAufbauen();
          });
      });
    }

    /* ---------- Start ---------- */
    if (GROESSEN.length) {
      var startVar = findeVariante(ausAdresse()) || ausKnoepfen() || findeVariante(STARTVARIANTE);
      var startG = startVar ? groesseAusWert((startVar.optionen || [])[groesseIdx]) : 0;
      if (GROESSEN.indexOf(startG) < 0) {
        startG = GROESSEN.indexOf(GRUNDB) >= 0 ? GRUNDB : GROESSEN[0];
      }
      groesseSetzen(startG, false);
    }
    vorschaufelder();
    farbskala();
    inhaltsauswahlAusblenden();
    groessenauswahlAusblenden();
    variantePruefen();

    var gesichert = null, ausKorb = false;
    try {
      if (bearbeitung.id) gesichert = localStorage.getItem('hwd-entwurf-' + bearbeitung.id);
      if (gesichert) ausKorb = true;
      else gesichert = localStorage.getItem(speicherSchluessel);
    } catch (e) { gesichert = null; }

    if (d.korbhinweis && bearbeitung.key) d.korbhinweis.hidden = false;

    if (gesichert && zustandLesen(gesichert)) {
      if (ausKorb) motiveNachholen();
      else {
        var weg = 0;
        SEITEN.forEach(function (sn) {
          var s = z.seiten[sn];
          s.elemente = s.elemente.filter(function (e) {
            if (e.typ === 'bild') { weg++; return false; }
            return true;
          });
        });
        if (weg > 0) fehler('Texte und Anordnung sind zurück. '
          + (weg === 1 ? 'Das Motiv' : 'Die ' + weg + ' Motive')
          + ' musst du neu auswählen – Dateien lassen sich im Browser nicht speichern.');
      }
    } else if (bearbeitung.key) {
      fehler('Der gespeicherte Entwurf liegt nicht mehr auf diesem Gerät. '
        + 'Gestalte die Position bitte neu – die alte bleibt so lange im Warenkorb.');
    }

    neuAufbauen();
    stapelKnoepfe();
    ereignis('configurator_opened', { produkt: root.getAttribute('data-handle') });

    setInterval(function () {
      if (variantePruefen()) { neuAufbauen(); return; }
      var f = form();
      if (!f) return;
      if (!f.querySelector('input[data-hwd-prop]')) {
        propsSchreiben();
        dateienSyncen();
        alteFelderAusblenden();
      }
    }, 500);

    window.addEventListener('resize', zeichneBald, { passive: true });
    window.HWDFlaecheDebug = {
      zustand: function () { return z; },
      bilder: function () { return bilder; },
      variante: function () { return variante; },
      zeichne: zeichne
    };
  }

  function boot() {
    [].slice.call(document.querySelectorAll('[data-hwd-flaeche]')).forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
